import { render, staticRenderFns } from "./BajasCobranzaEditar.vue?vue&type=template&id=4561decb&"
import script from "./BajasCobranzaEditar.vue?vue&type=script&lang=ts&"
export * from "./BajasCobranzaEditar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports